import React from 'react'
import ZemplerResults from './zempler-results'
import CaponTapResults from './cap-on-tap-results'

const ResultsCard = ({ variant }) => {
  if (variant === 'capital-on-tap') {
    return <CaponTapResults />
  } else {
    return <ZemplerResults />
  }
}

export default ResultsCard
